<template>
  <el-date-picker
    v-model="dates"
    :picker-options="pickerOptions"
    :clearable="false"
    :editable="false"
    type="daterange"
    :unlink-panels="true"
    class="date-width"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    range-separator="至"
    value-format="yyyy-MM-dd"
    :default-value="new Date()"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
  export default {
    data() {
      return {
        dates: this.dateValue,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate());
          },
          shortcuts: [
            {
              text: '当天',
              onClick(picker) {
                let start = new Date();
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate())
                const end = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一周',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 29);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 90);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                picker.$emit('pick', [start, end]);
              }
            }]
        }
      }
    },
    watch: {
      dates: function (newVal, oldVal) {
        this.$emit("update:dateValue", newVal);
      },
    },
    name: "date-picker",
    model: {
      prop: 'dateValue',
      event: 'change'
    },
    props: {
      dateValue: {
        type: Array,
        default: []
      }
    },
    methods: {
      reset(val){
        this.dates=val;
      }
    }
  }
</script>

<style scoped>
  .date-width{
    width: 390px;
  }
</style>



// WEBPACK FOOTER //
// src/components/date-picker/index.vue